import axios from "axios";
import store from "./redux/store";
import {
    setAllDetails,
    setDisplacements,
    setFuels,
    setLoggedIn,
    setCollapseLogInAlertCode,
    setMakes,
    setModels,
    setSeries,
    setTextSearchJobs,
    setWorkOrders,
    setOperations,
    setShowLoader,
    setCarJobs,
    setLoaderCar,
    setSystems
} from "./redux/listsSlice";
import {
    setCount,
    setDayCount,
    setLicense,
    setOpenDayClicksEndedAlert,
    setServerIsNotRespondingAlert,
    setOpenTooManySessions,
    setOpenLicenseEndedClicksAlert,
    setCustomAlertMessage
} from './redux/licenseSlice';
import {
    initDiffFlag,
    initSdhHourPrice,
    initShowCarTable,
    initShowClientTable,
    initShowComplexity,
    initWorkUpdateFlag,
    changeShowCompanyInfo,
    changeShowFromAccount,
    changeShowLogoOnLeft,
    changeCompanyName,
    changeOrganization,
    changeCompanyTin,
    changeCompanyAddress,
    changeCompanyPhoneNumber,
    changeCompanyLogoObjectUrl,
    setHasPrintSettings,
    initVATs, initMileageType, initSettingsProps,
} from "./redux/settingsSlice";
import {setLogin} from "./redux/accountSlice";
import {setFriendRequests, setFriends, setPendingFriends} from "./redux/friendSlice";
import {getEndpointUrl} from './utils/endpointUrl';
import {setJobs} from "./redux/jobsSlice";
import {filterDetail, filterJob} from './pages/calculatorParts/TableSums.js';

function getApiBaseUrl() {
    const url = getEndpointUrl(process.env.REACT_APP_API ?? '');
    return url;
}

const instance = axios.create({
    baseURL: getApiBaseUrl(), // 'http://localhost:3001'
    withCredentials: true,
    credentials: true,
    headers: {
        "Content-type": "application/json",
        "Cache-Control": "no-cache, no-store, no-transform"
    }
});
const delay = (ms) => new Promise(res => setTimeout(res, ms));//Для тестов задержка ответа
function catchServerError(error) {
    if (error.response && error.response.status) {
        switch (error.response.status) {
            case 404:
                return;
            case 401:
                console.warn('Not logged in', error);
                forceLogout();
                break;
            case 403:
                if (error.response.data?.reason) {
                    console.warn('Access click limits exhausted', error);
                    break;
                }
                console.warn('Access denied', error);
                forceLogout(403);
                break;
            case 417:
                console.warn('User suspended', error);
                forceLogout(417);
                break;
            case 418:
            case 429:
                console.warn('Access limits exceeded', error);
                forceLogout(429);
                break;
            case 400:
                console.error('Invalid request error', error);
                break;
            case 500:
            case 507:
            default:
                console.error('Unknown server error', error);
        }
    } else {
        console.error('Unknown client/server error', error);
    }
}

function catchEmptyResponse(error) {
    if (!error.response) {
        store.dispatch(setServerIsNotRespondingAlert(true));
    }
}

export function getCarMakes(year, callback) {
    if (year) {
        store.dispatch(setLoaderCar({loader: "makes", value: true}));
        instance.get('/make/' + year).then((resp) => {
            console.log('make', resp)
            store.dispatch(setLoaderCar({loader: "makes", value: false}));
            store.dispatch(setMakes(resp.data))
            callback()
        }).catch(error => {
            store.dispatch(setLoaderCar({loader: "makes", value: false}));
            catchServerError(error);
        });
    } else {

        store.dispatch(setMakes([]))
    }
}

export function getCarSeries(year, make, callback) {
    if (year && make) {
        store.dispatch(setLoaderCar({loader: "series", value: true}));
        instance.get('/serie/' + year + '/' + make.make_id).then((resp) => {
            console.log('serie', resp)
            store.dispatch(setLoaderCar({loader: "series", value: false}));
            store.dispatch(setSeries(resp.data))
            callback()
        }).catch(error => {
            store.dispatch(setLoaderCar({loader: "series", value: false}));
            catchServerError(error);
        });
    } else {
        store.dispatch(setSeries([]))
    }
}

export function getCarModels(year, make, serie, callback) {

    if (year && make && serie) {
        store.dispatch(setLoaderCar({loader: "models", value: true}));
        instance.get('/model/' + year + '/' + make.make_id + '/' + serie.serie_id).then((resp) => {
            console.log('model', resp)
            store.dispatch(setLoaderCar({loader: "models", value: false}));
            if (resp.data) {
                store.dispatch(setModels(resp.data))
            } else {
                store.dispatch(setModels([]))
            }
            callback(resp)
        }).catch(error => {
            store.dispatch(setLoaderCar({loader: "models", value: false}));
            catchServerError(error);
        });
    } else {
        store.dispatch(setModels([]))
    }
}

export function getCarFuels(model, callback) {
    if (model) {
        store.dispatch(setLoaderCar({loader: "fuels", value: true}));
        instance.get('/fuel/' + model.model_id).then((resp) => {
            console.log('fuel', resp)
            store.dispatch(setLoaderCar({loader: "fuels", value: false}));
            if (resp.data) {
                store.dispatch(setFuels(resp.data))
            } else {
                store.dispatch(setFuels([]))
            }
            callback(resp)
        }).catch(error => {
            store.dispatch(setLoaderCar({loader: "fuels", value: false}));
            catchServerError(error);
        });
    } else {
        store.dispatch(setFuels([]))
    }
}

export function getCarDisplacement(model, fuel, callback) {
    if (model) {
        store.dispatch(setLoaderCar({loader: "displacements", value: true}));
        instance.get('/displacement/' + model.model_id + '/' + (fuel ? fuel.fuel : '-')).then((resp) => {
            console.log('displacement', resp)
            store.dispatch(setLoaderCar({loader: "displacements", value: false}));
            if (resp.data) {
                resp.data.forEach((displacement) => {
                    if (displacement.displacement === '') {
                        displacement.displacement = '-'
                    }
                })
                store.dispatch(setDisplacements(resp.data))
            } else {
                store.dispatch(setDisplacements([]))
            }
            callback(resp)
        }).catch(error => {
            store.dispatch(setLoaderCar({loader: "displacements", value: false}));
            catchServerError(error);
        });
    } else {
        store.dispatch(setDisplacements([]))
    }
}

export function getSystems() {
    instance.get("/systems")
        .then((resp) => {
            if (resp.data) {
                store.dispatch(setSystems(resp.data));
            }
        }).catch(error => {
        store.dispatch(setShowLoader(false))
        catchServerError(error);
    });
}

export function getTextSearch(model, fuel, displacement) {
    store.dispatch(setShowLoader(true))
    if (model && fuel) {
        instance.get('/job/' +
            model.model_id + '/' +
            fuel.fuel + '/' +
            (displacement ? displacement.displacement : '-')).then((resp) => {
            //console.log('job', resp)
            store.dispatch(setShowLoader(false))
            if (resp.data) {
                let tempResp = []
                resp.data.forEach((value) => {
                    tempResp.push({
                        custom: Boolean(value.custom),
                        job_id: value.job_id,
                        detail: {
                            part_id: value.part_id,
                            part_name: value.part_name,
                            super_system_id: value.super_system_id,
                            super_system: value.super_system,
                            system_id: value.system_id,
                            system: value.system
                        },
                        other: value.other,
                        operation: {
                            operation_id: value.operation_id,
                            operation_name: value.operation,
                        },
                        owned: Boolean(value.owned),
                        sdh_hour: value.sdh_hour,
                        hourPrice: Number(store.getState().settings.sdhHourPrice),
                        difficulty: 1,
                        user_code: value.user_code,
                        user_num: value.user_num

                    })
                })
                store.dispatch(setTextSearchJobs(tempResp));

                store.dispatch(setCarJobs(resp.data));
            } else {
                store.dispatch(setTextSearchJobs([]))
                store.dispatch(setCarJobs([]));
            }
        }).catch(error => {
            store.dispatch(setShowLoader(false))
            catchServerError(error);
        });
    } else {
        store.dispatch(setShowLoader(false))
        store.dispatch(setTextSearchJobs([]))
        store.dispatch(setCarJobs([]));
    }
}

/*
export function getSuperSystem(model, fuel, displacement, setSuperSystems, callback) {
    if (model && fuel) {
        instance.get('/supersystem/' + model.model_id + '/' + fuel.fuel + '/' + (displacement ? displacement.displacement : '-'))
            .then((resp) => {
                console.log('supersystem', resp)
                if (resp.data) {
                    setSuperSystems(resp.data)
                    callback && callback()
                } else {
                    setSuperSystems([])
                }
            }).catch(error => {
            catchServerError(error);
        });
    } else {
        setSuperSystems([])
    }
}
export function getSystem(model, fuel, displacement, superSystem, setSystems, callback) {
    if (model && fuel) {
        instance.get('/system/' + model.model_id + '/' + fuel.fuel + '/' + (displacement ? displacement.displacement : '-') + '/' + superSystem.system_id)
            .then((resp) => {
                console.log('system', resp)
                if (resp.data) {
                    setSystems(resp.data)
                    callback()
                } else {
                    setSystems([])
                }
            }).catch(error => {
            catchServerError(error);
        });
    } else {
        setSystems([])
    }
}
export function getDetails(model, fuel, displacement, system, setDetails, callback) {
    if (model && fuel) {
        instance.get('/part/' + model.model_id + '/' + fuel.fuel + '/' + (displacement ? displacement.displacement : '-') + '/' + system.system_id)
            .then((resp) => {
                console.log('part', resp)
                if (resp.data) {
                    setDetails(resp.data)
                    callback()
                } else {
                    setDetails([])
                }
            }).catch(error => {
            catchServerError(error);
        });
    } else {
        setDetails([])
    }
}
export function getOperations(model, fuel, displacement, detail, setOperations, callback) {
    if (model && fuel) {
        instance.get('/operation/' + model.model_id + '/' + fuel.fuel + '/' + (displacement ? displacement.displacement : '-') + '/' + detail.part_id)
            .then((resp) => {
                console.log('operation', resp)
                if (resp.data) {
                    setOperations(resp.data)
                    callback()
                } else {
                    setOperations([])
                }
            }).catch(error => {
            catchServerError(error);
        });
    } else {
        setOperations([])
    }
}
*/

export function getAllDetails() {
    instance.get('/allparts/-')
        .then((resp) => {
            console.log('allparts', resp)
            if (resp.data) {
                store.dispatch(setAllDetails(resp.data))
            } else {
                store.dispatch(setAllDetails([]))
            }
        }).catch(error => {
        catchServerError(error);
    });
}

export function getJobH(model, fuel, displacement, detail, operation, setJobH) {
    if (model && fuel) {
        instance.get('/jobh/' + model.model_id + '/' + fuel.fuel + '/' + (displacement ? displacement.displacement : '-') + '/' + detail.part_id + '/' + operation.operation_id)
            .then((resp) => {
                console.log('jobh', resp)
                setJobH(resp.data)
            }).catch(error => {
            catchServerError(error);
        });
    } else {
        setJobH([])
    }
}

export function getJobHours(jobId, callback) {
    instance.get('/job_direct/' + jobId)
        .then((resp) => {
            console.log('job_direct', resp)
            if (resp.data) {
                callback(resp)
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 403) {
                console.log('error', error);
                console.log('error.response', error.response);

                switch (error.response.data.reason) {
                    case 1:
                        store.dispatch(setOpenLicenseEndedClicksAlert(true));
                        return;
                    case 2:
                        store.dispatch(setOpenDayClicksEndedAlert(true));
                        return;
                    default:
                }
            }
            catchEmptyResponse(error);
            catchServerError(error);
        });
}

export function signin(login, password, loadingStatus) {
    store.dispatch(setCollapseLogInAlertCode(0));
    if (login && password) {
        loadingStatus(true);
        instance.post('/auth', {'username': login, 'password': password})
            .then((resp) => {
                //console.log('auth', resp)
                loadingStatus(false);
                if (resp.status === 200 && resp.data) {
                    store.dispatch(setLoggedIn(true))
                    store.dispatch(setLogin(resp.data.login))
                }
                // console.log('signin status', resp.status);
            }).catch(error => {
            //console.log('signin error ', error);
            loadingStatus(false);
            if (!error.response) {

                store.dispatch(setCollapseLogInAlertCode(-1));
            } else {
                const statusCode = error.response.status;

                if (statusCode === 429) {
                    store.dispatch(setOpenTooManySessions(true));
                }
                store.dispatch(setCollapseLogInAlertCode(statusCode));
            }
        });
    }
}

export function onLogout(alertCode = 0) {
    store.dispatch(setWorkOrders([]))
    store.dispatch(setLoggedIn(false))
    store.dispatch(setCollapseLogInAlertCode(alertCode))
}

export function logout() {
    instance.get('/logout').then((resp) => {
        console.log('logout', resp)
        if (resp.status === 200) {
            onLogout();
        }
    });
}

export function forceLogout(alertCode = 0) {
    if (store.getState().lists.loggedIn) {
        instance.get('/logout').then(resp => {
            console.log('forceLogout', resp);
        }).catch((error) => console.error('Server error on Log-out', error));
    }
    onLogout(alertCode);
}

export function checkAuth() {
    instance.get('/authcheck').then((resp) => {
        // console.log('authcheck', resp)
        if (resp.status === 200) {
            store.dispatch(setLoggedIn(true))
            store.dispatch(setLogin(resp.data.login))
        }
    })
        .catch(function (error) {
            console.log('Unauthorized');
        });
}

export function license(callback) {
    instance.get('/license')
        .then((resp) => {
            //console.log('license', resp)
            if (resp.status === 200 && resp.data) {
                store.dispatch(setLicense(resp.data))
                callback()
            } else {
                store.dispatch(setLicense(
                    {
                        "code": 1,
                        "data": {
                            "id": null,
                            "name": "norms-start-1m",
                            "title": null,
                            "maxConnections": 2,
                            "dateBegin": "2022-06-10T21:00:00.000Z",
                            "dateEnd": "2022-07-10T21:00:00.000Z",
                            "count": 1496,
                            "dayCount": 200,
                            "dayCountTime": "2022-06-15T13:17:14.000Z",
                            "valid": 1
                        }
                    }
                ))
            }
        }).catch(error => {
        catchServerError(error);
    });
}

export function getFriends(loader= null) {
    loader && loader(true)
    instance.get('/friendship/friends')
        .then((resp) => {
            console.log('/friendship/friends', resp)
            if (resp.status === 200) {
                store.dispatch(setFriends(resp.data))
            }
            loader && loader(false)
        }).catch(function (error) {
        loader && loader(false)
        console.log('No friends');
        store.dispatch(setFriends([]));
        catchServerError(error);
    });
}

export function getFriendRequests() {
    instance.get('/friendship/requests').then((resp) => {
        console.log('/friendship/requests', resp)
        if (resp.status === 200) {
            store.dispatch(setFriendRequests(resp.data))
        }
    }).catch(function (error) {
        console.log('No friend requests');
        store.dispatch(setFriendRequests([]));
        catchServerError(error);
    });
}

export function getPendingFriends(loader= null) {
    loader && loader(true)
    instance.get('/friendship/pending').then((resp) => {
        console.log('/friendship/pending', resp)
        if (resp.status === 200) {
            store.dispatch(setPendingFriends(resp.data))
        }
        loader && loader(false)
    }).catch(function (error) {
        loader && loader(false)
        console.log('No pending friend requests');
        store.dispatch(setPendingFriends([]));
        catchServerError(error);
    });
}

export function deleteFriend(username, loader=null) {
    loader && loader(true)
    instance.post('/friendship/delete_friend', {username: username}).then((resp) => {
        console.log('/friendship/delete_friend', resp)
        if (resp.status === 200) {
            getFriends(loader)
            return;
        }
        loader && loader(false)
    }).catch(function (error) {
        loader && loader(false)
        console.log('Friend not deleted');
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

export function deletePendingFriend(username, loader=null) {
    loader && loader(true)
    instance.post('/friendship/delete/friend', {username: username}).then((resp) => {
        //console.log('/friendship/delete/friend', resp)

        if (resp.status === 200) {
            getPendingFriends(loader);
            return;
        }
        loader && loader(false)
    }).catch(function (error) {
        loader && loader(false)
        //console.log('/friendship/delete/friend', error);
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

export function addFriend(username, callback) {
    instance.post('/friendship/add_friend', {username: username}).then((resp) => {
        //console.log('/friendship/add_friend', resp)
        if (resp.status === 200) {
            getFriends();
            getPendingFriends();

            callback && callback(true, 200);
        }
    }).catch(function (error) {
        const data = error.response?.data ?? null;
        //console.log('Friend not added');
        if (data.errorCode) {
            store.dispatch(setCustomAlertMessage({
                isOpen: true,
                messageCode: data.errorCode
            }));
        } else {
            catchEmptyResponse(error);
            catchServerError(error);
        }
        const status = error.response ? error.response.status : 0;
        callback && callback(false, status);

    });
}

export function confirmFriend(username, action, callback) {
    instance.post('/friendship/confirm_friend', {username: username, action: action}).then((resp) => {
        console.log('/friendship/confirm_friend', resp)
        if (resp.status === 200) {
            getFriends()
            getPendingFriends()

            callback && callback(true);
        }
    }).catch(function (error) {
        console.log('Friend not accepted');
        catchEmptyResponse(error);
        catchServerError(error);

        callback && callback(false);
    });
}

//
// export function registerEmployee(email, password) {
//     instance.put('/users/creat/' + email + '/' + password).then((resp) => {
//         console.log('/users/creat/', resp)
//         if (resp.status === 200) {
//             getEmployees()
//         }
//     }).catch(function (error) {
//         console.log('Employee not registered');
//     });
// }
//
// export function deleteEmployee(email) {
//     instance.put('/users/delete/' + email).then((resp) => {
//         console.log('/users/delete/', resp)
//         if (resp.status === 200) {
//             getEmployees()
//         }
//     }).catch(function (error) {
//         console.log('Employee not deleted');
//     });
// }

export function getPricePerHour() {
    instance.get('/settings/price_per_hour')
        .then((resp) => {
            //console.log('price_per_hour', resp)
            if (resp.data) {
                store.dispatch(initSdhHourPrice(resp.data[0].price_per_hour))
            }
        }).catch(error => {
        catchServerError(error);
    });
}

export function getVAT() {
    instance.get('/settings/vat')
        .then((resp) => {
            // console.log('getVAT', resp);

            if (resp.data) {
                store.dispatch(initVATs(resp.data));
            }
        }).catch(error => {
        catchServerError(error);
    });
}

export function getShowComplexity() {
    instance.get('/settings/showComplexity')
        .then((resp) => {
            //console.log('showComplexity', resp)
            if (resp.data && resp.status === 200) {
                if (resp.data[0].showComplexity !== 0) {
                    store.dispatch(initShowComplexity(true))
                } else {
                    store.dispatch(initShowComplexity(false))
                }
            }
        }).catch(error => {
        catchServerError(error);
    });
}

export function getShowCarTable() {
    instance.get('/settings/showCarTable')
        .then((resp) => {
            // console.log('showCarTable', resp)
            if (resp.data && resp.status === 200) {
                store.dispatch(initShowCarTable(Boolean(resp.data[0].showCarTable)))
            }
        }).catch(error => {
        catchServerError(error);
    });
}

export function getShowClientTable() {
    instance.get('/settings/showClientTable')
        .then((resp) => {
            //console.log('showClientTable', resp)
            if (resp.data && resp.status === 200) {
                store.dispatch(initShowClientTable(Boolean(resp.data[0].showClientTable)))
            }
        }).catch(error => {
        catchServerError(error);
    });
}

export function sendVATsValues(vats) {
    const data = {...vats};

    instance.post('/settings/vat', data)
        .then((resp) => {
            console.log('sendVATsValues', resp);
        }).catch(error => {
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

export function setShowComplexity(showComplexity) {
    instance.put('/settings/set_showComplexity/' + Number(showComplexity))
        .then((resp) => {
            console.log('set_showComplexity', resp)
        }).catch(error => {
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

export function setShowCarTable(showCarTable) {
    instance.put('/settings/set_showCarTable/' + Number(showCarTable))
        .then((resp) => {
            console.log('set_showCarTable', resp)
        })
        .catch(error => {
            catchEmptyResponse(error);
            catchServerError(error);
        });
}

export function setShowClientTable(showClientTable) {
    instance.put('/settings/set_showClientTable/' + Number(showClientTable))
        .then((resp) => {
            console.log('set_showClientTable', resp)
        }).catch(error => {
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

export function getSettingsProps() {
    instance.get('/settings/props')
        .then((resp) => {
            if (resp.data) {
                store.dispatch(initSettingsProps(resp.data))
            }
        }).catch(error => {
        catchServerError(error);
    });
}

export function setMileageType(mileageType) {
    instance.put('/settings/set_mileage_type/' + mileageType)
        .then((resp) => {
            console.log('set_mileage_type', resp)
        }).catch(error => {
        catchEmptyResponse(error);
        catchServerError(error);
    })
}

export function setUpdateWorkOrder(showClientTable) {
    instance.put('/settings/set_edit_work_order/' + Number(showClientTable))
        .then((resp) => {
            console.log('set_edit_work_order', resp)
        }).catch(error => {
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

export function getDiffFlag() {
    instance.get('/settings/diffFlag')
        .then((resp) => {
            //console.log('diffFlag', resp)
            if (resp.data) {
                store.dispatch(initDiffFlag(resp.data[0].diffFlag))
            }
        }).catch(error => {
        catchServerError(error);
    });
}

// export function getShowHours() {
//     instance.get('/settings/showHours').then((resp) => {
//         console.log('showHours', resp)
//         if (resp.data) {
//             store.dispatch(initShowHours(resp.data[0].showHours))
//         }
//     });
// }

export function setDiffFlag(diffFlag) {
    instance.put('/settings/set_diffFlag/' + Number(diffFlag))
        .then((resp) => {
            console.log('set_diffFlag', resp)
        }).catch(error => {
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

// export function setShowHours(showHours) {
//     instance.put('/settings/set_showHours/' + Number(showHours)).then((resp) => {
//         console.log('set_showHours', resp)
//     });
// }

export function setSdhHourPrice(price) {
    instance.put('/settings/set_pph/' + price)
        .then((resp) => {
            console.log('set_pph', resp)
        }).catch(error => {
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

export function getCount(callback) {
    instance.get('/licensecheck')
        .then((resp) => {
            console.log('licensecheck', resp)
            if (resp.status === 200 && resp.data) {
                store.dispatch(setCount(resp.data.readCount));
                store.dispatch(setDayCount(resp.data.dayCount));
                callback && callback();
            } else if (resp.status === 404) {
                console.log('no license')
            }
        }).catch(error => {
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

export function successWorkOrder(order) {
    instance.post('/send_work_order', order)
        .then((resp) => {
        }).catch(error => {
        if (error.response?.status === 400) {
            store.dispatch(setServerIsNotRespondingAlert(true));
        }
        // временно игнорировать отказы
        if (error.response && error.response.status >= 401) {
            return;
        }
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

export function sendWorkOrder(work) {
    const isEdit = store.getState().settings.editWorkOrder;
    if (isEdit === 0 && work) return;

    const jobs = store.getState().jobs.jobs;
    const filteredJobs = jobs.filter(job => filterJob(job) && filterDetail(job));
    if (jobs.length !== filteredJobs.length) {
        store.dispatch(setJobs(filteredJobs));
    }
    const car = {...JSON.parse(sessionStorage.getItem('form'))};
    car.jobs = filteredJobs;
    if (car.jobs.length === 0) return;
    instance.post('/send_work_order', car)
        .then((resp) => {
            if (resp.data) {
                car.workorder_id = resp.data.workorder_id;

                sessionStorage.setItem('form', JSON.stringify(car))
            }

            getWorkOrders();
        }).catch(error => {
        if (error.response?.status === 400) {
            if (error.response?.data?.error_code) {
                store.dispatch(setCustomAlertMessage({
                    isOpen: true,
                    messageCode: error.response.data.error_code
                }));
            } else {
                store.dispatch(setServerIsNotRespondingAlert(true));
            }
        }
        // временно игнорировать отказы
        if (error.response && error.response.status >= 401) {
            return;
        }
        catchEmptyResponse(error);
        catchServerError(error);
    });
}

export function getWorkOrders() {
    instance.get('/work_orders').then((resp) => {
        //console.log('work_orders', resp)
        if (resp.status === 200) {
            //TODO JSON DB
            //store.dispatch(setWorkOrders(resp.data.map(value => JSON.parse(value.document))))
            store.dispatch(setWorkOrders(resp.data.map(v => {
                if (typeof v.document === 'object' && v.document !== null) {
                    return {...v.document, order_date: v.order_date};
                }
                if (typeof v.document !== 'string') {
                    return {...v.document, order_date: v.order_date};
                }
                try {
                    let document = JSON.parse(v.document);
                    return {...document, order_date: v.order_date};
                } catch {
                    return null;
                }
            })))
        } else {
            store.dispatch(setWorkOrders([]))
        }
    }).catch(function (error) {
        console.log('No work orders');
        store.dispatch(setWorkOrders([]));
        catchServerError(error);
    });
}

export function deleteCustomJob(job_id) {
    instance.delete('/delete_custom_job/' + job_id)
        .then((resp) => {
            console.log('delete_custom_job', resp)

        }).catch(error => {
        catchEmptyResponse(error);
        catchServerError(error);
    });
}


export async function searchCar(search) {
    const queryString =
        "?" +
        new URLSearchParams(
            Object.fromEntries(
                Object.entries(search).filter(
                    ([_, v]) => v !== null && v !== undefined && v !== ""
                )
            )
        ).toString();

    const resp = await instance.get("/search/work_orders" + queryString);
    if (resp.status !== 200) return [];
    // await delay(5000);
    //TODO JSON DB
    // return resp.data.map(v => JSON.parse(v.document));
    return resp.data.map(v => {
        if (typeof v.document === 'object' && v.document !== null) {
            return {...v.document, order_date: v.order_date};
        }
        if (typeof v.document !== 'string') {
            return {...v.document, order_date: v.order_date};
        }
        try {
            let document = JSON.parse(v.document);
            return {...document, order_date: v.order_date};
        } catch {
            return null;
        }
    });
}

export function abcParts(txt, findAllFlag) {
    return instance.get('/abcparts/' + (txt === '' ? '-' : txt) + '/' + Number(findAllFlag))
        .then((resp) => {
            console.log('abcparts', resp)
            if (resp.data) {
                store.dispatch(setAllDetails(resp.data))
            } else {
                store.dispatch(setAllDetails([]))
            }
        })
        .catch(function (error) {
            console.log('Parts not found');
            catchServerError(error);
        });
}

export function abcOperations(part_id, index, callback) {
    instance.get('/abcoperations/' + part_id)
        .then((resp) => {
            console.log('abcoperations', resp)
            store.dispatch(setOperations({operations: resp.data, index: index}))
            // callback()
        }).catch(error => {
        catchServerError(error);
    });
}

//#region CompanyInfo

function defaultLoad(promise, reducer, getValue) {
    return promise.then(resp => {
        const value = getValue(resp.data);
        store.dispatch(reducer(value));
        return value;
    }).catch(error => {
        const value = getValue(undefined);
        store.dispatch(reducer(value));
        catchServerError(error);
        return value;
    });
}

function defaultSend(promise) {
    return promise.then(resp => {
        return true;
    }).catch(error => {
        catchEmptyResponse(error);
        catchServerError(error);
        return false;
    });
}

export function loadPrintSettings() {
    return getShowCompanyInfo().then(showCompanyInfo => {
        if (showCompanyInfo) {
            return Promise.all([
                getShowFromAccount().then(showFromAccount => Promise.all([
                    getOrganization(showFromAccount),
                    getCompanyTin(showFromAccount),
                ])),
                getShowLogoOnLeft(),
                getCompanyName(),
                getCompanyAdress(),
                getCompanyPhoneNumber(),
                getCompanyLogo(),
            ])
                .then(() => {
                    store.dispatch(setHasPrintSettings(true));
                    return true;
                })
                .catch(() => {
                    store.dispatch(setHasPrintSettings(false));
                    return false;
                });
        } else {
            store.dispatch(setHasPrintSettings(false));
            return false;
        }
    });
}

export function getShowCompanyInfo() {
    return defaultLoad(
        instance.get('/settings/get_showCompanyInfo'),
        changeShowCompanyInfo,
        data => data ? data.value : false,
    );
}

export function getShowFromAccount() {
    return defaultLoad(
        instance.get('/settings/get_showFromAccount'),
        changeShowFromAccount,
        data => data ? data.value : false,
    );
}

export function getShowLogoOnLeft() {
    return defaultLoad(
        instance.get('/settings/get_showLogoOnLeft'),
        changeShowLogoOnLeft,
        data => data ? data.value : false,
    );
}

export function getOrganization(isGlobal) {
    const type = isGlobal ? 'global' : 'local';

    return defaultLoad(
        instance.get(`/settings/get_organization/${type}`),
        changeOrganization,
        data => data ? data.value : '',
    );
}

export function getCompanyName() {
    return defaultLoad(
        instance.get('/settings/get_companyName'),
        changeCompanyName,
        data => data ? data.value : '',
    );
}

export function getCompanyTin(isGlobal) {
    const type = isGlobal ? 'global' : 'local';

    return defaultLoad(
        instance.get(`/settings/get_companyTin/${type}`),
        changeCompanyTin,
        data => data ? data.value : '',
    );
}

export function getCompanyAdress() {
    return defaultLoad(
        instance.get('/settings/get_companyAdress'),
        changeCompanyAddress,
        data => data ? data.value : '',
    );
}

export function getCompanyPhoneNumber() {
    return defaultLoad(
        instance.get('/settings/get_companyPhoneNumber'),
        changeCompanyPhoneNumber,
        data => data ? data.value : '',
    );
}

export function getCompanyLogo() {
    return defaultLoad(
        instance.get('/settings/get_companyLogo', {
            responseType: 'blob',
            headers: {
                'Content-Type': 'image/png'
            },
        }),
        changeCompanyLogoObjectUrl,
        data => {
            if (data) {
                const blob = new Blob([data], {type: 'image/png'});

                if (blob && blob.size !== 0) {
                    return URL.createObjectURL(blob);
                }
            }
            return null;
        }
    );
}

export function setShowCompanyInfo(value) {
    return defaultSend(instance.post('/settings/set_showCompanyInfo', {value: value}));
}

export function setShowFromAccount(value) {
    return defaultSend(instance.post('/settings/set_showFromAccount', {value: value}));
}

export function setShowLogoOnLeft(value) {
    return defaultSend(instance.post('/settings/set_showLogoOnLeft', {value: value}));
}

export function setOrganization(value) {
    return defaultSend(instance.post('/settings/set_organization', {value: value}));
}

export function setCompanyName(value) {
    return defaultSend(instance.post('/settings/set_companyName', {value: value}));
}

export function setCompanyTin(value) {
    return defaultSend(instance.post('/settings/set_companyTin', {value: value}));
}

export function setCompanyAdress(value) {
    return defaultSend(instance.post('/settings/set_companyAdress', {value: value}));
}

export function setCompanyPhoneNumber(value) {
    return defaultSend(instance.post('/settings/set_companyPhoneNumber', {value: value}));
}

export function setCompanyLogo(file) {
    if (!file) {
        deleteCompanyLogo();
        return;
    }

    const formData = new FormData();
    formData.append('file', file);

    return defaultSend(instance.post('/settings/set_companyLogo', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    }));
}

export function deleteCompanyLogo() {
    return defaultSend(instance.delete('/settings/delete_companyLogo'));
}

//#endregion
